import React from 'react'

import { useDispatch, useSelector } from 'customizer/hooks'
import * as questionPanelActions from 'customizer/questionPanel/actions'
import * as questionPanelSelectors from 'customizer/questionPanel/selectors'
import * as stocksSelectors from 'customizer/stocks/selectors'
import OutOfStockMessageCard from 'themes/common/components/OutOfStockMessageCard'
import ErrorMessageCard from 'themes/common/components/ErrorMessageCard'
import SubmitAction from 'themes/common/components/SubmitAction'
import useOutOfStockMessageCard from 'themes/common/hooks/useOutOfStockMessageCard'

import './ActionSection.scss'

const ActionSection = () => {
  const dispatch = useDispatch()
  const isSelectionOutOfStock = useSelector(stocksSelectors.isSelectionOutOfStockSelector)
  const showSubmitError = useSelector(questionPanelSelectors.showSubmitErrorSelector)
  const { setShowOutOfStockMessageCard, showOutOfStockMessageCard } = useOutOfStockMessageCard(isSelectionOutOfStock)

  return (
    <>
      {showSubmitError && (
        <div onClick={() => dispatch(questionPanelActions.hideSubmitError())}>
          <ErrorMessageCard
            className="add-to-cart-error__message"
            message={<span>There was an error adding your product to the cart, please try again.</span>}
          />
        </div>
      )}

      {showOutOfStockMessageCard && <OutOfStockMessageCard onClick={() => setShowOutOfStockMessageCard(false)} />}

      <div className="finish-customization">
        <SubmitAction
          autoResize
          className="action-section__button"
          loading="circularCircle"
          showOutOfStockMessageCard={showOutOfStockMessageCard}
          setShowOutOfStockMessageCard={setShowOutOfStockMessageCard}
        />
      </div>
    </>
  )
}

export default ActionSection
